import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { clonePollRequested } from 'features/polls/actions';
import { Poll, PollPayload } from 'features/polls/types';
import { selectPoll } from 'features/polls/pollsSlice';
import i18n from 'i18n';

export function* clonePollSaga(action: ReturnType<typeof clonePollRequested>) {
  const poll: Poll = yield select(selectPoll, action.payload);
  if (!poll) {
    return;
  }

  const pollPayload: PollPayload = {
    question: i18n.t('polls:clone_question', { question: poll.question }),
    choices:
      poll.type !== 'free' && poll.choices ? poll.choices.map((choice) => choice.text) : undefined,
    type: poll.type,
    anonymous: poll.anonymous,
  };

  yield call(SignalingSocket.send, { event: 'createPoll', data: pollPayload });
}
